export const BLOG_BASE_PATH = '/blog'
